import { cn } from '@glomopay/utils';
import { type ComponentProps, type FC, lazy, Suspense } from 'react';

import type { GenericErrorIllustration } from './generic-error-illustration';

type GenericErrorIllustrationProps = ComponentProps<typeof GenericErrorIllustration>;

// Error screens are often reached because chunks failed to load, so a failed import must render nothing instead of throwing.
const GenericErrorIllustrationChunk = lazy(() =>
  import('./generic-error-illustration')
    .then(({ GenericErrorIllustration }) => ({ default: GenericErrorIllustration }))
    .catch(() => ({ default: () => null })),
);

export const LazyGenericErrorIllustration: FC<GenericErrorIllustrationProps> = (props) => (
  <Suspense fallback={<div className={cn('h-[138px] w-[278px]', props.className)} />}>
    <GenericErrorIllustrationChunk {...props} />
  </Suspense>
);
